import React, { Suspense } from 'react';
import { themes } from '../../ThemeOptions';
import Skeletons from './Skeleton';
var loading = function (ioMode, ioTheme, styleName) {
    return React.createElement(Skeletons, { count: 1, ioMode: ioMode, ioTheme: ioTheme, styleName: styleName });
};
var BootStrapTextBox = React.lazy(function () {
    return import('../../bootstrap-components/components/BTTextBox');
});
var bootStrapTextBox = function (props) {
    return (React.createElement(BootStrapTextBox, { handleChange: props.handleChange, styleName: props.hasError ? 'danger' : props.styleName, label: props.label, ioTheme: props.ioTheme, ioMode: props.ioMode, style: props.style, mandatory: props.mandatory, placeHolder: props.placeHolder, hasError: props.hasError, errorMessage: props.errorMessage, displayType: props.displayType, value: props.value, defaultValue: props.defaultValue, disabled: props.disabled, configId: props.configId, type: props.type, isButtonTextBox: props.isButtonTextBox, onBlur: props.onBlur, className: props.className, height: props.height, width: props.width, icon: props.icon, handleIconClick: props.handleIconClick, isInlineGridComponent: props.isInlineGridComponent, isFilterComponent: props.isFilterComponent, iconClicked: props.iconClicked, occuranceNumber: props.occuranceNumber }));
};
export var TextBox = function (props) {
    var componentToDisplay;
    switch (props.ioTheme.uiLibrary) {
        case 'materialui':
            componentToDisplay = bootStrapTextBox(props);
        default:
            componentToDisplay = bootStrapTextBox(props);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Suspense, { fallback: loading(props.ioMode, props.ioTheme, props.styleName) }, componentToDisplay)));
};
TextBox.defaultProps = {
    styleName: 'primary',
    label: 'TextBox',
    ioTheme: themes[0],
    ioMode: 'light',
    isInlineGridComponent: false,
    isFilterComponent: false
};
//# sourceMappingURL=TextBox.js.map